"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImap = createImap;
exports.dismissBanner = dismissBanner;
exports.endpoints = void 0;
exports.getAccount = getAccount;
exports.getAccounts = getAccounts;
exports.getAuthUrl = getAuthUrl;
exports.getImapConfig = getImapConfig;
exports.getImapReconnect = getImapReconnect;
exports.getReconnectUrl = getReconnectUrl;
exports.getSyncStatus = getSyncStatus;
exports.removeAccount = removeAccount;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _moment = _interopRequireDefault(require("moment"));
var _get = _interopRequireDefault(require("lodash/get"));
var _invert = _interopRequireDefault(require("lodash/invert"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _constants = require("../utils/constants");
var _excluded = ["syncEngineMessages", "onmailMessages"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var endpoints = exports.endpoints = {
  getAuthUrl: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/email_connection/oauth/url");
    }
  },
  getReconnectUrl: {
    method: 'GET',
    url: function url(ecUUID) {
      return "/".concat(_constants.API_V1, "/email_connection/oauth/").concat(ecUUID, "/reconnection");
    }
  },
  getImapConfig: {
    method: 'GET',
    url: function url(emailAddress) {
      return "/".concat(_constants.API_V1, "/email_connection/imap/").concat(emailAddress, "/config");
    }
  },
  getImapReconnect: {
    method: 'GET',
    url: function url(ecUUID) {
      return "/".concat(_constants.API_V1, "/email_connection/imap/").concat(ecUUID, "/reconnection");
    }
  },
  createImap: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/email_connection/imap");
    }
  },
  getAccounts: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/email_connection/authorization");
    }
  },
  getAccount: {
    method: 'GET',
    url: function url(ecUUID) {
      return "/".concat(_constants.API_V1, "/email_connection/authorization/").concat(ecUUID);
    }
  },
  removeAccount: {
    method: 'DELETE',
    url: function url(ecUUID) {
      return "/".concat(_constants.API_V1, "/email_connection/authorization/").concat(ecUUID);
    }
  },
  getSyncStatus: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/email_connection/sync_history");
    }
  },
  dismissBanner: {
    method: 'DELETE',
    url: function url(ecUUID) {
      return "/".concat(_constants.API_V1, "/email_connection/consent_screen/").concat(ecUUID);
    }
  }
};
/**
 * Get the OAuth URL for the first time.
 * @param {string} emailAddress - email address to connect
 * @param {ConnectionType} connectionType - type of third-party service that
 * sync engine supports
 */
function getAuthUrl(_x, _x2, _x3) {
  return _getAuthUrl.apply(this, arguments);
}
/**
 * Get the OAuth URL for reconnecting third-party account.
 *
 * @param {string} ecUUID: unique ID for third-party email connection
 */
function _getAuthUrl() {
  _getAuthUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(connectionType, redirectUrl, _ref) {
    var auth, emailAddress, optionals, _endpoints$getAuthUrl, method, url, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth, emailAddress = _ref.emailAddress;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            connectionType: connectionType,
            redirectUrl: redirectUrl,
            emailAddress: emailAddress
          }), (0, _requests.withOptional)('paramsFormat', {
            snakify: false
          }))(_utils.defaultOptionals);
          _endpoints$getAuthUrl = endpoints.getAuthUrl, method = _endpoints$getAuthUrl.method, url = _endpoints$getAuthUrl.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context.sent;
          if (!(res.status !== 200)) {
            _context.next = 8;
            break;
          }
          throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);
        case 8:
          return _context.abrupt("return", res);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getAuthUrl.apply(this, arguments);
}
function getReconnectUrl(_x4, _x5, _x6) {
  return _getReconnectUrl.apply(this, arguments);
}
/**
 * Gets the IMAP configuration to prepopulate for the user.
 *
 * @param {string} emailAddress - email address to get IMAP config for
 * @param {?string} provider - Specific the IMAP provider
 */
function _getReconnectUrl() {
  _getReconnectUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(ecUUID, redirectUrl, _ref2) {
    var auth, optionals, _endpoints$getReconne, method, url, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          auth = _ref2.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withOptional)('paramsFormat', {
            snakify: false
          }), (0, _requests.withParams)({
            redirectUrl: redirectUrl
          }))(_utils.defaultOptionals);
          _endpoints$getReconne = endpoints.getReconnectUrl, method = _endpoints$getReconne.method, url = _endpoints$getReconne.url;
          _context2.next = 5;
          return (0, _requests.request)(url(ecUUID), method, optionals);
        case 5:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getReconnectUrl.apply(this, arguments);
}
function getImapConfig(_x7, _x8) {
  return _getImapConfig.apply(this, arguments);
}
/**
 * Gets the IMAP configuration for an existing connection.
 *
 * @param {string} ecUUID - unique ID for the third-party email connection
 */
function _getImapConfig() {
  _getImapConfig = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(emailAddress, _ref3) {
    var auth, provider, optionals, _endpoints$getImapCon, method, url, suffixPreset, email, res;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          auth = _ref3.auth, provider = _ref3.provider;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$getImapCon = endpoints.getImapConfig, method = _endpoints$getImapCon.method, url = _endpoints$getImapCon.url;
          suffixPreset = (0, _get["default"])(_constants.standardProviderSuffix, provider);
          email = !!suffixPreset ? "sample".concat(suffixPreset) : emailAddress;
          _context3.next = 7;
          return (0, _requests.request)(url(email), method, optionals);
        case 7:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getImapConfig.apply(this, arguments);
}
function getImapReconnect(_x9, _x10) {
  return _getImapReconnect.apply(this, arguments);
}
/**
 * Connects an IMAP account to the user's account.
 *
 * @param {ImapConfig} imapConfig - IMAP configurations
 */
function _getImapReconnect() {
  _getImapReconnect = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(ecUUID, _ref4) {
    var auth, optionals, _endpoints$getImapRec, method, url, res;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          auth = _ref4.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$getImapRec = endpoints.getImapReconnect, method = _endpoints$getImapRec.method, url = _endpoints$getImapRec.url;
          _context4.next = 5;
          return (0, _requests.request)(url(ecUUID), method, optionals);
        case 5:
          res = _context4.sent;
          return _context4.abrupt("return", res);
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _getImapReconnect.apply(this, arguments);
}
function createImap(_x11, _x12) {
  return _createImap.apply(this, arguments);
}
function _createImap() {
  _createImap = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(imapConfig, _ref5) {
    var auth, optionals, _endpoints$createImap, method, url, res;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          auth = _ref5.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)((0, _mapValues["default"])(imapConfig, function (val, key) {
            // Trim the string except password field
            if (val.trim && key !== 'password') {
              return val.trim();
            } else return val;
          })))(_utils.defaultOptionals);
          _endpoints$createImap = endpoints.createImap, method = _endpoints$createImap.method, url = _endpoints$createImap.url;
          _context5.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context5.sent;
          if (!(res.status !== 200)) {
            _context5.next = 8;
            break;
          }
          throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);
        case 8:
          return _context5.abrupt("return", res);
        case 9:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _createImap.apply(this, arguments);
}
/**
 * Returns a list of all third-party accounts connected to user's OnMail
 * account.
 */
function getAccounts(_x13) {
  return _getAccounts.apply(this, arguments);
}
/**
 * Returns information about a single third-party account connected to a user's
 * OnMail account.
 *
 * @param {string} ecUUID - unique ID for third-party email connection
 */
function _getAccounts() {
  _getAccounts = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref6) {
    var auth, optionals, _endpoints$getAccount, method, url, res, invertedProviderSuffix, correctConnectionType, correctInsertTime, transformer;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          transformer = function _transformer(result) {
            var authorizations = result.authorizations;
            return _objectSpread(_objectSpread({}, result), {}, {
              authorizations: authorizations.map(function (account) {
                return _objectSpread(_objectSpread({}, account), {}, {
                  connectionType: correctConnectionType(account),
                  insertTime: correctInsertTime(account)
                });
              })
            });
          };
          correctInsertTime = function _correctInsertTime(_ref12) {
            var insertTime = _ref12.insertTime;
            return _moment["default"].isMoment(insertTime) ? insertTime.unix() : insertTime;
          };
          correctConnectionType = function _correctConnectionTyp(_ref11) {
            var emailAddress = _ref11.emailAddress,
              connectionType = _ref11.connectionType;
            if (connectionType !== _constants.connectionTypes.DEFAULT) {
              return connectionType;
            }
            var suffix = emailAddress.replace(/.*@/g, '').toLowerCase();
            return invertedProviderSuffix["@".concat(suffix)] || connectionType;
          };
          auth = _ref6.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$getAccount = endpoints.getAccounts, method = _endpoints$getAccount.method, url = _endpoints$getAccount.url;
          _context6.next = 8;
          return (0, _requests.request)(url(), method, optionals);
        case 8:
          res = _context6.sent;
          invertedProviderSuffix = (0, _invert["default"])(_constants.standardProviderSuffix);
          return _context6.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
            result: transformer(res.result)
          }));
        case 11:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _getAccounts.apply(this, arguments);
}
function getAccount(_x14, _x15) {
  return _getAccount.apply(this, arguments);
}
/**
 * Deletes the third-party account from OnMail.
 *
 * @param {string} ecUUID - unique ID for third-party email connection
 */
function _getAccount() {
  _getAccount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(ecUUID, _ref7) {
    var auth, optionals, _endpoints$getAccount2, method, url, res;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          auth = _ref7.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$getAccount2 = endpoints.getAccount, method = _endpoints$getAccount2.method, url = _endpoints$getAccount2.url;
          _context7.next = 5;
          return (0, _requests.request)(url(ecUUID), method, optionals);
        case 5:
          res = _context7.sent;
          return _context7.abrupt("return", res);
        case 7:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _getAccount.apply(this, arguments);
}
function removeAccount(_x16, _x17) {
  return _removeAccount.apply(this, arguments);
}
/**
 * Gets the current synchronization progress of a pending account.
 *
 * @param {Auth} auth - User validated authentication
 */
function _removeAccount() {
  _removeAccount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(ecUUID, _ref8) {
    var auth, optionals, _endpoints$removeAcco, method, url, res;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          auth = _ref8.auth;
          optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
          _endpoints$removeAcco = endpoints.removeAccount, method = _endpoints$removeAcco.method, url = _endpoints$removeAcco.url;
          _context8.next = 5;
          return (0, _requests.request)(url(ecUUID), method, optionals);
        case 5:
          res = _context8.sent;
          return _context8.abrupt("return", res);
        case 7:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _removeAccount.apply(this, arguments);
}
function getSyncStatus(_x18) {
  return _getSyncStatus.apply(this, arguments);
}
/**
 * Dismiss the success banner after initial sync for a Retrofit account.
 *
 * @param {string} ecUUID - unique ID for third-party email connection
 */
function _getSyncStatus() {
  _getSyncStatus = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(_ref9) {
    var auth, optionals, _endpoints$getSyncSta, method, url, res, syncHistories;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          auth = _ref9.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$getSyncSta = endpoints.getSyncStatus, method = _endpoints$getSyncSta.method, url = _endpoints$getSyncSta.url;
          _context9.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context9.sent;
          if (!(res.status !== 200)) {
            _context9.next = 8;
            break;
          }
          throw new _requests.RequestError((0, _get["default"])(res, 'message'), '', res.status);
        case 8:
          syncHistories = res.result.syncHistories || [];
          return _context9.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
            result: _objectSpread(_objectSpread({}, res.result), {}, {
              syncHistories: syncHistories.map(function (_ref13) {
                var syncEngineMessages = _ref13.syncEngineMessages,
                  onmailMessages = _ref13.onmailMessages,
                  rest = (0, _objectWithoutProperties2["default"])(_ref13, _excluded);
                return _objectSpread(_objectSpread({}, rest), {}, {
                  synced: onmailMessages,
                  unsynced: syncEngineMessages
                });
              })
            })
          }));
        case 10:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _getSyncStatus.apply(this, arguments);
}
function dismissBanner(_x19, _x20) {
  return _dismissBanner.apply(this, arguments);
}
function _dismissBanner() {
  _dismissBanner = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(ecUUID, _ref10) {
    var auth, optionals, _endpoints$dismissBan, method, url, res;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          auth = _ref10.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$dismissBan = endpoints.dismissBanner, method = _endpoints$dismissBan.method, url = _endpoints$dismissBan.url;
          _context10.next = 5;
          return (0, _requests.request)(url(ecUUID), method, optionals);
        case 5:
          res = _context10.sent;
          return _context10.abrupt("return", res);
        case 7:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _dismissBanner.apply(this, arguments);
}
//# sourceMappingURL=retrofit.js.map